import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class FrenchDateAdapter extends NativeDateAdapter {

    override parse(value: any, _parseFormat: any): Date | null {
        if (typeof value === 'number') {
            return new Date(value);
        }
        if (!value) return null;

        // DD/MM/YYYY HH:mm
        const withTime = /^(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):(\d{2})$/.exec(value);
        if (withTime) {
            const [, d, m, y, h, min] = withTime;
            const date = new Date(+y, +m - 1, +d, +h, +min);
            return date.getDate() === +d && date.getMonth() === +m - 1 && date.getFullYear() === +y ? date : null;
        }

        // DD/MM/YYYY
        const dateOnly = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
        if (dateOnly) {
            const [, d, m, y] = dateOnly;
            const date = new Date(+y, +m - 1, +d);
            return date.getDate() === +d && date.getMonth() === +m - 1 && date.getFullYear() === +y ? date : null;
        }

        return null;
    }

    override format(date: Date, displayFormat: any): string {

        if (displayFormat === 'monthYearLabel') {
            return new Intl.DateTimeFormat('fr-FR', {
                month: 'long',
                year: 'numeric'
            }).format(date);
        }

        if (displayFormat === 'dd/MM/yyyy HH:mm') {
            const pad = (n: number) => n.toString().padStart(2, '0');
            return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} `
                + `${pad(date.getHours())}:${pad(date.getMinutes())}`;
        }

        // fallback = date complète FR (champ input)
        return new Intl.DateTimeFormat('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).format(date);
    }

    override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
        return ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
    }

}
